import { render, staticRenderFns } from "./BridgeList.vue?vue&type=template&id=9780e2b6&scoped=true"
import script from "./BridgeList.vue?vue&type=script&lang=js"
export * from "./BridgeList.vue?vue&type=script&lang=js"
import style0 from "./BridgeList.vue?vue&type=style&index=0&id=9780e2b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9780e2b6",
  null
  
)

export default component.exports